export default function EmptyState({ onVideoMode, onVoiceMode }) {
  return (
    <div className="flex flex-col items-center justify-center flex-1 px-4 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-gray-600">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      </div>
      <h2 className="text-2xl font-semibold text-gray-900 mb-2">How can I help you today?</h2>
      <p className="text-gray-600 mb-8 max-w-md">
        Start a conversation or begin a live inspection to analyze your home maintenance needs
      </p>
      
      {/* Quick Actions */}
      <div className="flex flex-col gap-4 w-full max-w-sm">
        <button
          onClick={onVideoMode}
          className="flex items-center gap-4 p-4 text-left border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors w-full"
        >
          <div className="w-10 h-10 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-blue-600">
              <path d="M23 7l-7 5 7 5V7z"/>
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
            </svg>
          </div>
          <div className="flex-1">
            <div className="font-medium text-gray-900">Start Live Inspection</div>
            <div className="text-sm text-gray-600">Real-time video analysis</div>
          </div>
        </button>
        
        <button
          onClick={onVoiceMode}
          className="flex items-center gap-4 p-4 text-left border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors w-full"
        >
          <div className="w-10 h-10 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-green-600">
              <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
              <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
              <line x1="12" y1="19" x2="12" y2="23"/>
              <line x1="8" y1="23" x2="16" y2="23"/>
            </svg>
          </div>
          <div className="flex-1">
            <div className="font-medium text-gray-900">Voice Conversation</div>
            <div className="text-sm text-gray-600">Talk with AI assistant</div>
          </div>
        </button>
      </div>
    </div>
  )
}
